<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(studentgroup.id)" v-if="$can('studentgroup-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="studentgroup.name"
                  v-model="studentgroup.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('studentgroups.name')"
                  :error-messages="errors.collect('studentgroup.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="studentgroup.educationprogram_id"
                  ref="course_id"
                  v-model="studentgroup.educationprogram_id"
                  :items="educationprograms"
                  item-text="dd_name"
                  item-value="id"
                  :label="$t('educationprograms.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('studentgroup.educationprogram_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="studentgroup.status"
                  v-model="studentgroup.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="$dd_student_group_status()"
                  :label="$t('studentgroups.status')"
                  :error-messages="errors.collect('studentgroup.status')"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2" v-if="studentgroup.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("participants.title") }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2"
                  color="success"
                  @click="courselistpopup_show"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>fas fa-plus</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("enrolments.enrol") }}</span>
                </v-btn>
              </template>
              <span>{{ $t("studentgroups.enrol_tooltip") }}</span>
            </v-tooltip>

            <router-link
              :to="BACKEND_URL + '/participants/create?from_module=studentgroups&from_id=' + studentgroup.id"
              v-if="$can('participant-create')"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" small v-bind="attrs" v-on="on">
                    <v-icon small>fas fa-plus</v-icon>
                    <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.new") }}</span>
                  </v-btn>
                </template>
                <span>{{ $t("studentgroups.new_tooltip") }}</span>
              </v-tooltip>
            </router-link>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2"
                  color="success"
                  @click="partlistpopup_show"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>fas fa-check-square</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.select") }}</span>
                </v-btn>
              </template>
              <span>{{ $t("studentgroups.select_tooltip") }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2"
                  color="error"
                  @click="delStudents()"
                  v-show="selectedParticipants.length > 0"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>fas fa-minus</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.remove") }}</span>
                </v-btn>
              </template>
              <span>{{ $t("studentgroups.remove_tooltip") }}</span>
            </v-tooltip>
          </v-app-bar>

          <v-divider></v-divider>

          <v-card-text>
            <v-flex md12>
              <v-data-table
                :headers="participant_headers"
                :items="participants"
                :items-per-page="participants.length"
                :options.sync="participant_pagination"
                :footer-props="{
                  showFirstLastPage: true,
                  'items-per-page-options': DATATABLE_ITEM_PER_PAGE_OPTIONS,
                  'items-per-page-all-text': $t('global.items_per_page_all_text'),
                  'items-per-page-text': $t('global.items_per_page_text'),
                  'page-text': $t('global.page_text')
                }"
                :server-items-length="participant_total"
                :loading="participant_show_loading"
                :loading-text="$t('global.loading_text')"
                :no-data-text="$t('global.no_data_text')"
                :no-results-text="$t('global.no_results_text')"
                item-key="id"
                :show-select="true"
                v-model="selectedParticipants"
                :must-sort="true"
              >
                <template v-slot:item.company_id="{ item }">
                  {{ item.companies.map((i) => i.name).join(", ") }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <router-link
                    :to="{ path: BACKEND_URL + '/participants/edit/' + item.id, props: { id: item.id } }"
                    v-if="$can('participant-edit')"
                  >
                    <action-button type="edit" :icon_only="true" small />
                  </router-link>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>

        <v-expansion-panels v-model="clpsLogExpand" class="cstm-filter mt-4 elevation-0" ref="log_expansion_panels" v-if="studentgroup.id">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsLogIcon }}</v-icon>
                {{ $t("logs.title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="log_headers"
                    :items="logs"
                    :items-per-page="logs.length"
                    :options.sync="log_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="log_total"
                    :loading="log_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.user_id="{ item }">
                      {{ item.user.person.first_name + " " + item.user.person.last_name }}
                    </template>

                    <template v-slot:item.action_id="{ item }">
                      <div v-if="(item.action_name && item.action_link) || (item.action_name_2 && item.action_link_2)">
                        <!-- ACTION 1-->
                        <router-link :to="`/app${item.action_link}`" v-if="item.action_name && item.action_link">
                          {{ item.action_name }}
                        </router-link>

                        <!-- ACTION 2-->
                        <span v-if="item.action_name_2 && item.action_link_2">
                          /
                          <router-link :to="`/app${item.action_link_2}`">
                            {{ item.action_name_2 }}
                          </router-link>
                        </span>
                      </div>
                      <div v-else>
                        {{ item.action_name || item.action_id }}
                      </div>
                    </template>

                    <template v-slot:item.created_at="{ item }">
                      {{ moment(item.created_at).format(MYSQL_DATETIME_FORMAT) }}
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-form>

    <participantListPopup
      :key="'plp-' + reRenderParticipantPopup"
      :show="showParticipantListPopup"
      :except_ids="participantIds"
      sort_by="last_name"
      from_module="studentgroups"
      @callback_partlistpopup_cancel="callback_partlistpopup_cancel"
      @callback_partlistpopup_submit="callback_partlistpopup_submit"
    />

    <courseListPopup
      :show="showCourseListPopup"
      :except_ids="courseIds"
      :status_ids="[1]"
      :single_select="true"
      :number_of_enrolees="selectedParticipants.length"
      @callback_courselistpopup_cancel="callback_courselistpopup_cancel"
      @callback_courselistpopup_submit="callback_courselistpopup_submit"
    />

    <multiEnrolmentFormPopup
      :key="'mefp-' + reRender"
      :show="showMultiEnrolmentFormPopup"
      :course_id="currentCourseID"
      :course_uuid="currentCourseUUID"
      :autofill_data="currentAutoFillData"
      @callback_multienrpopup_submit="callback_multienrpopup_submit"
      @callback_multienrpopup_cancel="callback_multienrpopup_cancel"
    />
  </v-container>
</template>

<script>
import participantListPopup from "../../participants/partials/ParticipantListPopup.vue"
import courseListPopup from "../../courses/partials/CourseListPopup.vue"
import multiEnrolmentFormPopup from "../../enrolments/partials/MultiEnrolmentFomPopup.vue"

export default {
  name: "StudentGroupForm",

  props: ["id"],

  components: {
    participantListPopup,
    courseListPopup,
    multiEnrolmentFormPopup
  },

  data() {
    return {
      page_title: "",
      predata: {},
      studentgroup: {
        has_locale: false
      },
      dictionary: {
        attributes: {
          "studentgroup.name": this.$t("studentgroups.name"),
          "studentgroup.status": this.$t("studentgroups.status"),
          "studentgroup.educationprogram_id": this.$t("educationprograms.title")
        }
      },

      educationprograms: [],

      participants: [],
      participant_total: 0,
      participant_show_loading: false,
      participant_show_filter: false,
      participant_refresh: false,
      participant_pagination: {
        page: this.$getLocalStorage("__sgParticipantListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      logs: [],
      log_ids: [],
      log_total: 0,
      log_show_loading: false,
      log_refresh: false,
      log_pagination: {
        page: this.$getLocalStorage("__sgLogListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["created_at"],
        sortDesc: [true]
      },

      clpsLogIcon: "mdi-expand-all-outline",
      clpsLogExpand: undefined,

      reRenderParticipantPopup: 0,
      showParticipantListPopup: false,
      participantIds: [],

      showCourseListPopup: false,
      courseIds: [],
      selectedParticipants: [],

      showMultiEnrolmentFormPopup: false,
      coursePopupData: null,
      currentAutoFillData: null,
      currentCourseID: null,
      currentCourseUUID: null,
      reRender: 1
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.studentgroup, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    participant_headers: {
      get() {
        return [
          { text: this.$t("participants.first_name"), value: "first_name" },
          { text: this.$t("participants.last_name"), value: "last_name" },
          { text: this.$t("participants.email"), value: "email" },
          { text: this.$t("participants.mobile"), value: "mobile" },
          { text: this.$t("participants.company_id"), value: "company_id" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    log_headers: {
      get() {
        return [
          { text: this.$t("logs.id"), value: "id" },
          { text: this.$t("logs.user_id"), value: "user_id" },
          { text: this.$t("logs.action"), value: "action" },
          { text: this.$t("logs.record"), value: "action_id" },
          { text: this.$t("logs.ip_address"), value: "ip_address" },
          { text: this.$t("logs.created_at"), value: "created_at" }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  watch: {
    clpsLogExpand: {
      handler(newVal, oldVal) {
        this.clpsLogIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    log_refresh: {
      handler() {
        if (this.log_refresh) {
          this.log_list()
        }
      }
    },
    log_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__sgLogListPage", newVal.page)
          }

          this.log_refresh = true
        }
      }
    },
    participant_refresh: {
      handler() {
        if (this.participant_refresh && this.studentgroup.id) {
          this.participant_list()
        }
      }
    },
    participant_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__sgParticipantListPage", newVal.page)
          }

          this.participant_refresh = true
        }
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.load_dropdowns()

    if (!this.id) {
      this.studentgroup = {
        has_locale: false,
        status: this.$getDefaultDropdown(this.$dd_student_group_status())
      }

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.studentgroup))

      this.setPageTitle()
    } else {
      this.title = this.$t("studentgroups.update_title")

      axios
        .get(this.API_URL + "studentgroup/" + this.id)
        .then((res) => {
          this.studentgroup = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.studentgroup))

          this.setPageTitle()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    setPageTitle() {
      if (_.has(this.studentgroup, "id")) {
        this.page_title = this.$t("studentgroups.edit_studentgroup", {
          name: this.studentgroup.name
        })
      } else {
        this.page_title = this.$t("studentgroups.new_studentgroup")
      }
    },
    load_dropdowns() {
      axios
        .post(this.API_URL + "request/ddlists", [{ key: "educationprograms", module: "educationprograms", query: "show_all=true" }])
        .then((res) => {
          this.educationprograms = res.data.educationprograms
        })
    },
    participant_list() {
      if (this.studentgroup.id) {
        this.participant_show_loading = true

        let { sortBy, descending, page, itemsPerPage } = this.participant_pagination
        let query = this.$queryString(this.participant_pagination, {
          student_group_id: this.studentgroup.id,
          tenant_user_status: 1,
          tenant_id: this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`)
        })

        axios.get(this.API_URL + "participants?resourcetype=user-basic&" + query).then((res) => {
          this.participants = res.data.data
          this.participant_total = res.data.meta.total
          this.participant_refresh = false
          this.participant_show_loading = false
          this.participant_pagination.page = res.data.meta.current_page
          this.participant_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
      }
    },
    log_list() {
      if (this.studentgroup.id) {
        this.log_show_loading = true

        let ids = this.log_ids.join(",")
        let { sortBy, descending, page, itemsPerPage } = this.log_pagination
        let query = this.$queryString(this.log_pagination, { action_model: "studentgroup", action_id: this.studentgroup.id })

        axios
          .get(this.API_URL + "logs" + "?" + query)
          .then((res) => {
            this.logs = res.data.data
            this.log_total = res.data.meta.total
            this.log_refresh = false
            this.log_show_loading = false

            this.log_pagination.page = res.data.meta.current_page
            this.log_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.studentgroup.id) {
              // Create
              axios
                .post(this.API_URL + "studentgroup", {
                  name: this.studentgroup.name,
                  status: this.studentgroup.status,
                  educationprogram_id: this.studentgroup.educationprogram_id,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.studentgroup = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.studentgroup))
                      vm.setPageTitle()
                      vm.$router.replace(this.BACKEND_URL + `/studentgroups/edit/${vm.studentgroup.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "studentgroup", {
                  id: this.studentgroup.id,
                  name: this.studentgroup.name,
                  status: this.studentgroup.status,
                  educationprogram_id: this.studentgroup.educationprogram_id
                })
                .then((res) => {
                  vm.studentgroup = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.studentgroup))

                  vm.setPageTitle()
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "studentgroup/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/studentgroups")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    delStudents() {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .post(this.API_URL + "studentgroups/participants/delete", {
              id: this.studentgroup.id,
              participant_ids: this.selectedParticipants.map((a) => a.id).join(",")
            })
            .then((res) => {
              vm.participant_refresh = true
              vm.log_refresh = true
              vm.selectedParticipants = []
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    partlistpopup_show() {
      this.reRenderParticipantPopup++
      this.showParticipantListPopup = true
    },
    callback_partlistpopup_submit(data) {
      this.callback_partlistpopup_cancel()

      let ids = data.map((i) => i.id)
      let vm = this

      axios
        .post(this.API_URL + "studentgroup/participant/add", {
          id: this.studentgroup.id,
          participant_ids: ids.join(",")
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            vm.$awn.success(vm.$t("global.create_success"))
            vm.participant_refresh = true
            vm.log_refresh = true
          }
        })
        .catch((err) => console.log(err))
    },
    callback_partlistpopup_cancel() {
      this.showParticipantListPopup = false
    },

    courselistpopup_show() {
      if (this.selectedParticipants.length > 0) {
        this.reRender += 1
        this.showCourseListPopup = true
      } else {
        this.$awn.warning(this.$t("participants.no_participant_selected"))
      }
    },
    callback_courselistpopup_submit(data) {
      this.coursePopupData = data
      this.callback_courselistpopup_cancel()

      let ids = data.map((i) => i.id)
      let uuids = data.map((i) => i.uuid)
      let participants = this.selectedParticipants.map((i) => ({
        id: i.id,
        first_name: i.first_name,
        last_name: i.last_name,
        email: i.email,
        date_of_birth: i.date_of_birth,
        mobile: i.mobile,
        companies: i.companies || []
      }))

      this.currentAutoFillData = {
        company_id: null,
        company_vat: null,
        participants: participants
      }
      this.currentCourseID = ids.join(",")
      this.currentCourseUUID = uuids.join(",")
      this.showMultiEnrolmentFormPopup = true
    },
    callback_courselistpopup_cancel() {
      this.showCourseListPopup = false
    },
    coursePopupPostData(data) {
      let vm = this

      if (this.coursePopupData) {
        let ids = this.coursePopupData.map((i) => i.id)
        let pids = data.map((i) => i.participant_id)
        let eids = data.map((i) => i.enrolment_id)

        axios
          .post(this.API_URL + "participant/createAttendee", {
            participant_ids: pids.join(","),
            course_ids: ids.join(","),
            enrolment_ids: eids.join(","),
            site: process.env.VUE_APP_DOMAIN,
            subdomain: vm.SUBDOMAIN
          })
          .then((res) => {
            if (typeof res.data.errors !== "undefined") {
            } else {
              let json = res.data

              if (json.status) {
                vm.$awn.success(
                  json.hasOwnProperty("hasSkipUser") && json.hasSkipUser
                    ? vm.$t("enrolments.multi_enrolment_successful_with_skip")
                    : vm.$t("global.create_success")
                )
              } else {
                vm.$awn.alert(vm.$t("enrolments.multi_enrolment_failed"))
              }

              vm.course_refresh = true
            }
          })
          .catch((err) => console.log(err))
      }
    },
    callback_multienrpopup_submit(data) {
      if (data) {
        this.coursePopupPostData(data)
      } else {
        this.callback_multienrpopup_cancel()
      }
    },
    callback_multienrpopup_cancel() {
      this.currentAutoFillData = null
      this.currentCourseID = null
      this.currentCourseUUID = null
      this.showMultiEnrolmentFormPopup = false
    }
  }
}
</script>

<style scoped></style>
